import React, { useEffect } from "react";
import Page from "components/common/page/Page.component";
import UsersListContainer from "containers/management/users/list/UsersList.container";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const SUPERUSER = "superuser";

const UsersListPage = () => {
    const navigate = useNavigate()
    const { user } = useSelector((state) => state.user);

    useEffect(() => {
        if (user && user.role !== SUPERUSER) {
            navigate('/404')
        }
        // eslint-disable-next-line
    }, [user])

    return (
        <Page title="Utenti">
            {user?.role === SUPERUSER && <UsersListContainer />}
        </Page>
    );
};

export default UsersListPage;
